import { handleActions } from 'redux-actions';
import { DamzState } from '../../types';
import {
  initUserSettings,
  fetchMenuSettings,
  fetchMenuSettingsSuccess,
  fetchMenuSettingsFailure,
  setDisableSounds,
  setOnlyMyWatchers,
} from '../actions/settings';

const initialState: DamzState['settings'] = {
  disableSounds: false,
  onlyWatch: false,
  status: 'uninitialized',
};

const settings = handleActions<DamzState['settings'], any>(
  {
    [`${initUserSettings}`]: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    [`${fetchMenuSettings}`]: (state, action) => ({
      ...state,
      status: 'fetching',
    }),
    [`${fetchMenuSettingsSuccess}`]: (state, action) => ({
      ...state,
      ...action.payload,
      status: 'idle',
    }),
    [`${fetchMenuSettingsFailure}`]: (state, action) => ({
      ...state,
      status: 'idle',
      hasLegacyNotes: false,
      hasLegacyChat: false,
    }),
    [`${setDisableSounds}`]: (state, action) => ({
      ...state,
      disableSounds: action.payload.disable,
    }),
    [`${setOnlyMyWatchers}`]: (state, action) => ({
      ...state,
      onlyWatch: action.payload.only,
    }),
  },
  initialState
);

export default settings;
